const binding = { modules: {}, dataActions: {} };

    (binding.modules['dobbies-password-reset-verification'] = {
        c: () => require('partner/modules/dobbies-password-reset-verification/dobbies-password-reset-verification.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dobbies-password-reset-verification',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dobbies-password-reset-verification'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|dobbies-password-reset-verification|dobbies-password-reset-verification'] = {
                c: () => require('partner/modules/dobbies-password-reset-verification/dobbies-password-reset-verification.view.tsx'),
                cn: '__local__-__local__-dobbies-password-reset-verification'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };